/**
 * Thrown by an app's auth middleware when a login redirect has been initiated
 * and the page is about to navigate away. `useFetch` swallows it so no error UI
 * flashes during the redirect. Lives in the runtime (not the app's auth layer)
 * so `useFetch` can reference it without depending on any specific auth provider.
 */
export class AuthRedirectInProgressError extends Error {
  constructor() {
    super("Authentication redirect in progress");
    this.name = "AuthRedirectInProgressError";
  }
}
